import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { types, actions } from './reducer';
import { extractError } from '@iso/lib//helpers/api';
import CompositeProductService from '@iso/services/SettingsService/CompositeProductService';

function* viewCompositeProduct({ id }) {
    try {
        const response = yield call(CompositeProductService.getOne, id);
        yield put(actions.viewCompositeProductSucceeded(response.data));
    } catch (error) {
        yield put(actions.viewCompositeProductFailed(extractError(error)));
    }
}

function* watchViewCompositeProduct() {
    yield takeEvery(
        types.REQUEST_VIEW_COMPOSITE_PRODUCT,
        viewCompositeProduct,
    );
}

function* viewSaga() {
    yield all([
        fork(watchViewCompositeProduct),
    ]);
}

export default viewSaga;
